export default __webpack_public_path__ + "static/media/logo-LSPPM.48a7dcbe.png";